/* Sección 2 de la PDP: mecánica del carrusel.
   Port del carrusel de México (m3x1.js), acotado a [data-pdp-carousel].
   Vanilla, sin dependencias. Cada instancia se inicializa una sola vez. */

(function () {
  'use strict';

  /* Arrastre con el ratón para pistas con overflow (Mau, sesión 7).
     Solo actúa con ratón real: en táctil el scroll nativo manda (los
     mouse-events sintéticos post-touch llegan sin movimiento y no
     alcanzan el umbral). Un arrastre real suprime el click que el
     navegador dispara al soltar (si no, soltar sobre la imagen abriría
     el zoom, y sobre una miniatura saltaría de foto). */
  function enableMouseDrag(el, onRelease) {
    var down = false;
    var dragged = false;
    var startX = 0;
    var startLeft = 0;

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true;
      dragged = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) > 5) {
        dragged = true;
        el.classList.add('is-dragging');
      }
      if (dragged) {
        e.preventDefault();
        var previous = el.style.scrollBehavior;
        el.style.scrollBehavior = 'auto';
        el.scrollLeft = startLeft - dx;
        el.style.scrollBehavior = previous;
      }
    });

    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (dragged) {
        el.classList.remove('is-dragging');
        if (onRelease) onRelease();
        /* el click fantasma llega justo después del mouseup */
        window.setTimeout(function () { dragged = false; }, 0);
      }
    });

    el.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.pdpcInit === '1') return;
    root.dataset.pdpcInit = '1';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-thumb]'));
    var thumbsEl = root.querySelector('[data-carousel-thumbs]');

    if (!track || slides.length === 0) return;

    var activeIndex = 0;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      if (index === activeIndex) return;
      activeIndex = index;

      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
          revealThumb(thumb);
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    /* Al deslizar el carrusel la miniatura activa puede quedar fuera de la tira.
       Se arrastra la tira lo justo para que vuelva a verse. Con rects en vez de
       offsetLeft porque la tira no es el offsetParent de las miniaturas. */
    function revealThumb(thumb) {
      if (!thumbsEl) return;
      var t = thumb.getBoundingClientRect();
      var s = thumbsEl.getBoundingClientRect();
      var margin = 12;
      if (t.left < s.left + 4) {
        thumbsEl.scrollLeft -= s.left - t.left + margin;
      } else if (t.right > s.right - 4) {
        thumbsEl.scrollLeft += t.right - s.right + margin;
      }
    }

    /* Salto por miniatura: INSTANTÁNEO, a propósito.

       Los slides llevan `scroll-snap-stop: always` para que un swipe agresivo no
       salte tres fotos de golpe. El efecto secundario es que el navegador
       tampoco deja que un scroll SUAVE programático cruce varios puntos de
       encaje: `scrollTo({behavior:'smooth'})` hacia una foto lejana no emite ni
       un solo evento de scroll y la pista no se mueve.

       La salida de México era apagar el snap durante la animación y restaurarlo
       con un temporizador, pero eso es una carrera: si la animación no ha
       terminado cuando vuelve el `mandatory`, el navegador re-encaja al punto
       más cercano —el de partida— y la miniatura queda marcada sobre la imagen
       equivocada.

       Asignar scrollLeft con scroll-behavior en auto va a la posición exacta, ya
       encajada, sin animación que pueda interrumpirse. El deslizamiento con el
       dedo sigue siendo suave y con snap nativo: esto sólo afecta al salto por
       miniatura, donde además un corte seco se siente más directo. */
    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      var slide = slides[index];
      if (!slide) return;

      var left = slide.offsetLeft - slides[0].offsetLeft;
      var maxLeft = track.scrollWidth - track.clientWidth;
      if (left < 0) left = 0;
      if (left > maxLeft) left = maxLeft;

      setActive(index);

      var previous = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      track.style.scrollBehavior = previous;
    }

    function syncActiveFromScroll() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var nearest = 0;
      var nearestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var slideCenter = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      }
      setActive(nearest);
    }

    var rafPending = false;
    track.addEventListener(
      'scroll',
      function () {
        if (rafPending) return;
        rafPending = true;
        window.requestAnimationFrame(function () {
          rafPending = false;
          syncActiveFromScroll();
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-slide-index'), 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    });

    /* Arrastre de escritorio (Mau, sesión 7): la tira de miniaturas se
       arrastra para llegar más allá de la 8 (el money back), y la
       imagen grande cambia de foto con clic + arrastre. Durante el
       arrastre de la pista el snap está apagado (.is-dragging en CSS);
       al soltar se re-encaja en el slide más cercano. */
    if (thumbsEl) enableMouseDrag(thumbsEl, null);
    enableMouseDrag(track, function () {
      syncActiveFromScroll();
      goToSlide(activeIndex);
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToSlide(activeIndex + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToSlide(activeIndex - 1);
      }
    });

    /* El "hay más fotos" ya no lo comunica un degradado por JS sino el corte de
       la última miniatura contra el borde, que es puro CSS. */

    initZoom(root, goToSlide);
  }

  /* ---- Zoom accesible ---------------------------------------- */
  function initZoom(root, goToSlide) {
    var modal = root.querySelector('[data-zoom-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('[data-zoom-dialog]');
    var overlay = modal.querySelector('[data-zoom-overlay]');
    var closeBtn = modal.querySelector('[data-zoom-close]');
    var img = modal.querySelector('[data-zoom-img]');
    var prevBtn = modal.querySelector('[data-zoom-prev]');
    var nextBtn = modal.querySelector('[data-zoom-next]');
    var stage = modal.querySelector('[data-zoom-stage]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-zoom-trigger]'));
    var current = -1;
    var lastTrigger = null;
    var closeTimer = null;

    /* Navegación DENTRO del zoom (Mau, sesión 7): flechas rosas, swipe
       táctil y teclado. Solo recorre las imágenes (los vídeos no tienen
       trigger de zoom). La pista de abajo sigue al zoom para que al
       cerrar estés en la misma foto. */
    function syncZoomNav() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= triggers.length - 1;
    }

    function showZoom(i) {
      if (!img || i < 0 || i > triggers.length - 1) return;
      current = i;
      var t = triggers[i];
      img.src = t.getAttribute('data-zoom-src') || '';
      img.alt = t.getAttribute('data-zoom-alt') || '';
      syncZoomNav();
      if (goToSlide) {
        var slide = t.closest('[data-carousel-slide]');
        var idx = slide ? parseInt(slide.getAttribute('data-slide-index'), 10) : NaN;
        if (!isNaN(idx)) goToSlide(idx);
      }
    }

    function open(trigger) {
      if (!img) return;
      /* Si se reabre dentro de los 200ms del cierre, ese timer dejaría el
         modal hidden con .is-open puesto (invisible y con el scroll de la
         página bloqueado). Reproducido en el live, auditoría 2026-09-22. */
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastTrigger = trigger;
      current = triggers.indexOf(trigger);
      img.src = trigger.getAttribute('data-zoom-src') || '';
      img.alt = trigger.getAttribute('data-zoom-alt') || '';
      syncZoomNav();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      /* La burbuja de Chatwoot se aparta mientras el zoom está abierto (CSS
         en snippets/chatwoot-widget.liquid). */
      document.documentElement.classList.add('pdp-modal-open');
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      if (dialog) dialog.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('pdp-modal-open');
      document.removeEventListener('keydown', onKeydown);
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        modal.hidden = true;
        if (img) img.src = '';
      }, 200);
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    function trapFocus(e) {
      if (!dialog) return;
      var focusables = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        showZoom(current + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        showZoom(current - 1);
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger);
      });
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { showZoom(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showZoom(current + 1); });

    /* Swipe con el dedo dentro del zoom: horizontal claro (dx > 48px y
       dominante sobre dy) → foto siguiente/anterior. */
    if (stage) {
      var touchX = 0;
      var touchY = 0;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - touchX;
        var dy = t.clientY - touchY;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          showZoom(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }
  }

  /* ============================================================
     Módulo de compra
     ============================================================ */

  /* Fecha de entrega en días LABORABLES, no naturales. "Llega en 1-4 días" en
     España se entiende como laborables, y contarlos como naturales adelantaría
     la fecha prometida hasta dos días en cualquier pedido de jueves o viernes.
     Ante la duda, prometer de más es peor que prometer de menos. */
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  /* España mantiene los meses COMPLETOS ('20-23 agosto'), como el live: el
     abreviado ('ago') es convención de México. Restaurado en el port de
     vuelta MX -> ES (oferta Firmeza, 2026-08-23). */
  var monthFormatter = null;
  function monthName(d) {
    if (!monthFormatter) {
      try {
        monthFormatter = new Intl.DateTimeFormat('es-ES', { month: 'long' });
      } catch (e) {
        monthFormatter = null;
      }
    }
    if (monthFormatter) return monthFormatter.format(d);
    return String(d.getMonth() + 1);
  }

  /* Rango compacto estilo México: "3-8 agosto", y si cruza de mes,
     "31 julio - 5 agosto". */
  function formatDateRange(from, to) {
    var m1 = monthName(from);
    var m2 = monthName(to);
    if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
      return from.getDate() + '-' + to.getDate() + ' ' + m1;
    }
    return from.getDate() + ' ' + m1 + ' - ' + to.getDate() + ' ' + m2;
  }

  /* Avisa al theme, a Rebuy y a quien escuche de que la cesta cambió.
     rebuy:cart.change es el que oye la Smart Cart de Rebuy. */
  function dispatchCartRefresh() {
    ['rebuy:cart.change', 'cart:refresh', 'cart:build', 'cart:updated'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) {
        /* que falte CustomEvent no puede romper el alta en cesta */
      }
    });
  }

  /* Atribución del advertorial (cookie skd_ref, la escribe
     js-skindion-atribucion.js; misma lectura que js-rebuy-garantia.js). */
  function esDelAdvertorial() {
    var partes = ('; ' + document.cookie).split('; skd_ref=');
    if (partes.length !== 2) return false;
    var crudo = decodeURIComponent(partes.pop().split(';').shift() || '');
    return crudo.split('|')[0] === 'protocolofacial';
  }

  /* Abre el cajón de la cesta sin navegar nunca a /cart. El clic al icono sólo
     se usa si Rebuy existe: es Rebuy quien intercepta ese enlace. Sin Rebuy, el
     clic navegaría, que es justo lo que no queremos. */
  function openCartDrawer() {
    var rebuy = window.Rebuy;
    var sc = rebuy && rebuy.SmartCart ? rebuy.SmartCart : null;

    if (sc) {
      /* 14j (verificado con el pane visible): show() de Rebuy no-opea si
         su flag `visible` ya es true. Mientras el pop-up de upgrade
         retiene el drawer (hide periódico), el handler de add de Rebuy
         re-marca visible=true con el DOM cerrado, y el show() del
         continuar no hacía nada. Poner el flag a false pasa por su
         setter reactivo y deja que show() corra el camino completo. */
      try { sc.visible = false; } catch (e) { /* solo es el flag */ }
      var methods = ['show', 'open', 'toggle'];
      for (var i = 0; i < methods.length; i++) {
        if (typeof sc[methods[i]] === 'function') {
          try {
            sc[methods[i]]();
            return true;
          } catch (e) {
            /* probamos el siguiente nombre conocido */
          }
        }
      }
    }

    if (rebuy) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        try {
          icon.click();
          return true;
        } catch (e) {
          /* nunca navegar como efecto secundario */
        }
      }
    }

    return false;
  }

  function initBuybox(root) {
    if (!root || root.dataset.mppInit === '1') return;
    root.dataset.mppInit = '1';

    var plans = Array.prototype.slice.call(root.querySelectorAll('[data-plan]'));
    var form = root.querySelector('[data-atc-form]');
    var variantInput = root.querySelector('[data-atc-variant]');
    var label = root.querySelector('[data-atc-label]');
    var button = root.querySelector('[data-atc-btn]');
    var errorEl = root.querySelector('[data-atc-error]');
    var shipWrap = root.querySelector('[data-ship-wrap]');
    var shipLine = root.querySelector('[data-ship-line]');
    var klarnaOfficial = root.querySelector('[data-klarna-official]');

    /* Sticky ATC (sección 18): mismo estado del buybox, otra piel. */
    var sticky = root.querySelector('[data-sticky]');
    var stickyName = root.querySelector('[data-sticky-name]');
    var stickySub = root.querySelector('[data-sticky-sub]');
    var stickySelect = root.querySelector('[data-sticky-select]');
    var stickyBtn = root.querySelector('[data-sticky-atc]');

    if (plans.length === 0 || !form) return;

    /* Altura REAL del sticky → variable CSS en <html>. La burbuja de Chatwoot
       se apoya en ella para subir exactamente encima del sticky (CSS en
       snippets/chatwoot-widget.liquid). Se publica al mostrarse, al cambiar
       de plan (el texto puede partir en dos líneas) y al cambiar el tamaño
       de la ventana. offsetHeight ya incluye padding + safe-area. En
       escritorio el sticky va display:none → 0 → no se publica. */
    function publishStickyHeight() {
      if (!sticky) return;
      var h = sticky.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--pdp-sticky-h', h + 'px');
    }

    function selectedPlan() {
      for (var i = 0; i < plans.length; i++) {
        var input = plans[i].querySelector('[data-plan-input]');
        if (input && input.checked) return plans[i];
      }
      return null;
    }

    /* Los enlaces de color tienen que llevar el plan que esté marcado AHORA,
       no el que había al renderizar el HTML. */
    function syncColorLinks(index) {
      root.querySelectorAll('.mpp__color a[href]').forEach(function (a) {
        try {
          var url = new URL(a.getAttribute('href'), window.location.origin);
          url.searchParams.set('plan', index);
          a.setAttribute('href', url.pathname + url.search);
        } catch (e) {
          /* un href raro no puede tumbar el módulo */
        }
      });
    }

    function sync() {
      var plan = selectedPlan();
      if (!plan) return;

      plans.forEach(function (p) {
        p.classList.toggle('is-selected', p === plan);
      });

      syncColorLinks(plan.getAttribute('data-plan-index'));

      var variantId = plan.getAttribute('data-variant-id') || '';
      var available = plan.getAttribute('data-available') === 'true';
      if (variantInput) variantInput.value = variantId;

      if (label) {
        /* Sin precio en el botón: solo el label del plan (pedido de Mau, sesión 4). */
        var text = plan.getAttribute('data-cta-label') || 'Añadir a la cesta';
        if (!available) {
          text = 'Agotado';
        }
        label.textContent = text;
      }

      if (button) button.disabled = !available || !variantId;

      if (stickyName) stickyName.textContent = plan.getAttribute('data-plan-name') || '';
      if (stickySub) {
        /* Sub sin precio (Mau, 2026-08-04): coste por sesión + "en casa".
           El precio queda en las cards y en el picker; si el plan no
           trae línea de sesión, cae al precio para no dejar hueco. */
        var money = plan.getAttribute('data-price-money') || '';
        var session = plan.getAttribute('data-session-line') || '';
        stickySub.textContent = session ? session + ' en casa' : money;
      }
      if (stickySelect) stickySelect.value = plan.getAttribute('data-plan-index');
      if (stickyBtn) stickyBtn.disabled = !available || !variantId;
      publishStickyHeight();

      /* Días de garantía del plan → barra de confianza (token [DIAS] en
         product-trust-bar.liquid). Starter 30 · Protocolo Firmeza 60; para el
         tráfico del advertorial (cookie skd_ref = protocolofacial, 14c) manda
         data-garantia-dias-adv si el plan lo trae, la misma promesa que
         enseñan sus chips y el labio del drawer (js-rebuy-garantia). */
      var dias = plan.getAttribute('data-garantia-dias') || '';
      var diasAdv = plan.getAttribute('data-garantia-dias-adv') || '';
      if (diasAdv && esDelAdvertorial()) dias = diasAdv;
      if (dias) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-garantia-dias-out]'), function (el) {
          if (el.textContent !== dias) el.textContent = dias;
        });
      }

      /* La línea se arma con nodos y textContent, nunca con innerHTML sobre los
         settings: son texto del editor, no HTML. */
      if (shipLine) {
        var prefix = plan.getAttribute('data-ship-prefix') || '';
        var rest = plan.getAttribute('data-ship-rest') || '';
        var min = parseInt(plan.getAttribute('data-ship-min'), 10);
        var max = parseInt(plan.getAttribute('data-ship-max'), 10);
        shipLine.textContent = '';

        if (!isNaN(min) && !isNaN(max) && (prefix || rest)) {
          var now = new Date();
          if (prefix) {
            var b1 = document.createElement('strong');
            b1.textContent = prefix;
            shipLine.appendChild(b1);
          }
          if (rest) {
            shipLine.appendChild(document.createTextNode(prefix ? ' ' + rest + ' ' : rest + ' '));
          }
          var b2 = document.createElement('strong');
          b2.textContent = formatDateRange(addBusinessDays(now, min), addBusinessDays(now, max));
          shipLine.appendChild(b2);
        }

        if (shipWrap) shipWrap.hidden = shipLine.childNodes.length === 0;
      }

      /* Compra única (14g): el placement de Klarna vive dentro de esa opción
         y solo se enseña con ella elegida. Es la única SIN suscripción, o
         sea la única donde Klarna existe de verdad (y cotiza 150 correcto). */
      var klarnaWrap = root.querySelector('[data-klarna-onetime]');
      if (klarnaWrap) klarnaWrap.hidden = !plan.hasAttribute('data-one-time');

      /* Klarna: el importe depende del plan (175/3 = 58,33 € pero 150/3 = 50 €),
         así que un importe fijo estaría mal en cuanto tocas el Starter. */
      var cents = parseInt(plan.getAttribute('data-price-cents'), 10);
      if (!isNaN(cents) && cents > 0) {
        /* El placement oficial espera unidades MENORES, no euros.

           OJO: la app de Klarna PISA este atributo con el precio del producto
           de la PÁGINA (skindion-rosa, 150 €), que no es el plan seleccionado
           (el Protocolo es otro producto, 175 €). Sin corregirlo, al cargar
           anunciaba plazos de 50 € con el Protocolo marcado. Se vigila el
           atributo y se repone, comparando antes para no entrar en bucle. */
        if (klarnaOfficial) {
          var quiero = String(cents);
          klarnaOfficial.setAttribute('data-purchase-amount', quiero);
          klarnaOfficial.__skdWant = quiero;
          if (!klarnaOfficial.__skdGuard && 'MutationObserver' in window) {
            klarnaOfficial.__skdGuard = new MutationObserver(function () {
              var want = klarnaOfficial.__skdWant;
              if (want && klarnaOfficial.getAttribute('data-purchase-amount') !== want) {
                klarnaOfficial.setAttribute('data-purchase-amount', want);
              }
            });
            klarnaOfficial.__skdGuard.observe(klarnaOfficial, {
              attributes: true, attributeFilter: ['data-purchase-amount']
            });
          }
        }

      }

      if (errorEl) errorEl.textContent = '';
    }

    plans.forEach(function (plan) {
      var input = plan.querySelector('[data-plan-input]');
      if (input) input.addEventListener('change', sync);

      /* La tarjeta entera es zona de toque, no sólo el radio. */
      plan.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          sync();
        }
      });
    });

    /* El select del sticky marca el radio real: un solo estado, un solo sync. */
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var target = plans[parseInt(stickySelect.value, 10)];
        var targetInput = target ? target.querySelector('[data-plan-input]') : null;
        if (targetInput && !targetInput.disabled) {
          targetInput.checked = true;
          sync();
        }
      });
    }

    /* El botón del sticky proxea al ATC real: mismo flujo AJAX + drawer
       (patrón del m3x1-sticky de MX). */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (button && !button.disabled) button.click();
      });
    }

    /* CTA del stack (sección 9; Mau, sesión 7): "EMPEZAR MI PROTOCOLO"
       añade a la cesta DE VERDAD — selecciona el plan Protocolo
       (respetando el color ya elegido) y proxea al ATC real, el mismo
       patrón que el sticky. Sin JS, su ancla a #planes sigue viva. */
    document.addEventListener('click', function (e) {
      var cta = e.target.closest ? e.target.closest('[data-stack-atc]') : null;
      if (!cta) return;
      /* Sin ATC utilizable (agotado o compra en vuelo) el ancla nativa a
         #planes sigue viva: no se cancela un clic que no se puede proxear
         (auditoría 2026-09-22: antes quedaba un clic muerto). */
      if (!button || button.disabled) return;
      e.preventDefault();
      var target = null;
      for (var i = 0; i < plans.length; i++) {
        var planName = plans[i].getAttribute('data-plan-name') || '';
        if (/protocolo/i.test(planName)) target = plans[i];
      }
      if (!target) target = plans[plans.length - 1];
      var input = target ? target.querySelector('[data-plan-input]') : null;
      if (input && !input.checked && !input.disabled) input.click();
      if (button && !button.disabled) button.click();
    });

    /* El sticky aparece al dejar atrás el marcador "Las cremas llegan
       hasta aquí" de la escena de cómo-funciona (Mau, sesión 7; antes
       era el formulario del buybox y a veces asomaba arriba del todo).
       [data-sticky-sentinel] vive en product-como-funciona.liquid; si
       la escena no está o el label va vacío, cae al formulario como
       antes. El [hidden] server-side evita el flash pre-JS. */
    if (sticky) {
      sticky.hidden = false;
      var sentinel = document.querySelector('[data-sticky-sentinel]') || form;
      if ('IntersectionObserver' in window) {
        var stickyIO = new IntersectionObserver(function (entries) {
          var entry = entries[entries.length - 1];
          var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          sticky.classList.toggle('is-visible', passed);
          /* La burbuja de Chatwoot escucha esta clase para subirse junto con
             el sticky y bajar cuando se va (CSS en snippets/chatwoot-widget.liquid). */
          if (passed) publishStickyHeight();
          document.documentElement.classList.toggle('pdp-sticky-on', passed);
        }, {
          /* Raíz extendida 20000px hacia ABAJO: el sentinel "intersecta" mientras
             esté debajo o dentro del viewport y deja de hacerlo SOLO al quedar
             arriba. Sin esto el observer solo avisa cuando el sentinel entra o
             sale del viewport, y un scroll rápido que lo salte entre dos frames
             (es un <g> de ~29px dentro del SVG de cómo-funciona) dejaba el sticky
             sin aparecer nunca (QA headless 2026-09-22: un scrollTo directo jamás
             lo disparaba en 375/320/412/768). */
          rootMargin: '0px 0px 20000px 0px'
        });
        stickyIO.observe(sentinel);
      }
      window.addEventListener('resize', publishStickyHeight);
    }

    /* El color recarga la página, así que el plan viaja en ?plan= */
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('plan');
    if (fromUrl !== null) {
      var target = plans[parseInt(fromUrl, 10)];
      if (target) {
        var targetInput = target.querySelector('[data-plan-input]');
        if (targetInput && !targetInput.disabled) targetInput.checked = true;
      }
    }

    /* PORT MX — Protocolo Firmeza nace suscrito: el plan puede declarar una
       2ª línea (gel automático con selling plan de Skio) en sus data-attrs. Va
       en el MISMO add atómico: si el gel falla, no se vende un Protocolo Firmeza sin
       su suscripción. El gel va PRIMERO porque Rebuy pinta newest-first y así
       el dispositivo queda arriba del drawer (lección de m3x1, 2026-06-24). */
    function buildItems(plan, variantId) {
      var items = [{ id: variantId, quantity: 1 }];
      if (!plan) return items;
      var subVariant = parseInt(plan.getAttribute('data-sub-variant') || '', 10);
      var subPlan = parseInt(plan.getAttribute('data-sub-plan') || '', 10);
      if (!isNaN(subVariant) && !isNaN(subPlan)) {
        var sub = { id: subVariant, quantity: 1, selling_plan: subPlan };
        var note = plan.getAttribute('data-sub-note');
        // PORT MX (Mau, 2026-08-22): la clave NO debe ser "Renovación" y la linea
        // del carrito debe EMPEZAR con "Hoy…". Rebuy pinta "clave : valor"; la clave
        // se esconde en el drawer via cart-gel-guard.js (CSS) y en el checkout nativo
        // se lee "Gel automático: Hoy $0 · …".
        if (note) sub.properties = { 'Gel automático': note };
        items.unshift(sub);
      }
      return items;
    }

    /* 14n — LA pipeline de compra, única para todos los caminos (submit
       directo, decisión del pop-up de upgrade). Deja la cesta y su
       descuento SIEMPRE coherentes:
       1. Cookie del cupón (el checkout la lee; gotcha de la 13c).
       2. El gel de la OTRA oferta sale y lo ya presente no se re-añade
          (14f: las ofertas son excluyentes y el dispositivo es el mismo
          producto; todo comparado como Number, el input da string).
       3. El cupón se aplica AL CARRITO con /cart/update.js {discount}:
          es lo único que reemplaza un código amarrado de una oferta
          probada antes (verificado en el live: 99,99 con "Skindion
          Starter" pasó a 125 con "Protocolo Firmeza"). Así el drawer
          enseña siempre el precio de verdad, no solo el checkout.
       Si cualquier red falla, el add sale igual y el interceptor del
       pagar (js-cart-descuento) es la última línea: nunca se bloquea
       una venta. */
    var GELES_OFERTA = [49514997154048, 49542155305216];

    function ejecutarCompra(plan) {
      var variantId = plan ? plan.getAttribute('data-variant-id') || '' : '';
      if (!variantId) return;

      if (errorEl) errorEl.textContent = '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }
      if (stickyBtn) {
        stickyBtn.disabled = true;
        stickyBtn.classList.add('is-loading');
      }

      var dCode = plan.getAttribute('data-discount-code') || '';
      var esCompraUnica = plan.hasAttribute('data-one-time');
      /* Compra única (14g): va SIN cupón. Si quedó la cookie de una oferta
         probada antes, fuera, o el checkout la aplicaría al precio real. */
      if (esCompraUnica) {
        try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
      }
      var descuentoListo = dCode
        ? fetch('/discount/' + encodeURIComponent(dCode)).catch(function () {})
        : Promise.resolve();

      descuentoListo.then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        /* Si la cesta no se puede LEER, no se ESCRIBE: tratarla como vacía
           re-añadía el dispositivo y el gel que ya estaban (2 dispositivos en
           cesta, la misma clase de bug que ES#2401). Reproducido en el live
           con un /cart.js en 503 (auditoría 2026-09-22). Mejor un error y
           que la clienta reintente. */
        .catch(function () { throw new Error('No se pudo leer la cesta. Inténtalo de nuevo.'); })
        .then(function (cart) {
          var quiere = buildItems(plan, variantId);
          var quiereIds = quiere.map(function (it) { return Number(it.id); });
          var updates = {};
          (cart.items || []).forEach(function (linea) {
            var vid = Number(linea.variant_id);
            if (GELES_OFERTA.indexOf(vid) !== -1 && quiereIds.indexOf(vid) === -1) {
              updates[linea.key] = 0;
            }
          });
          var faltan = quiere.filter(function (it) {
            return !(cart.items || []).some(function (linea) { return Number(linea.variant_id) === Number(it.id); });
          });
          var limpiar = Object.keys(updates).length
            ? fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).catch(function () {})
            : Promise.resolve();
          return limpiar.then(function () {
            if (!faltan.length) return null;
            return fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: faltan })
            }).then(function (res) {
              /* Una respuesta no-JSON (HTML de un 429/5xx) no debe enseñar a la
                 clienta "Unexpected token <": se cae a un mensaje genérico. */
              return res.json().catch(function () { return {}; }).then(function (data) {
                if (!res.ok) throw new Error(data.description || data.message || 'No se pudo añadir a la cesta. Inténtalo de nuevo.');
                return data;
              });
            });
          });
        })
        .then(function () {
          /* El cupón, AL CARRITO (paso 3 de la pipeline). Vacío = limpiar
             (compra única). Best-effort: el interceptor remata en el pagar. */
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: esCompraUnica ? '' : dCode })
          }).catch(function () {});
        })
        .then(function () {
          dispatchCartRefresh();
          openCartDrawer();
        })
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message || 'No se pudo añadir a la cesta. Inténtalo de nuevo.';
        })
        .then(function () {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
          if (stickyBtn) {
            stickyBtn.disabled = false;
            stickyBtn.classList.remove('is-loading');
          }
        });
      });
    }

    /* 14n (diseño de Mau): con el Starter elegido, el AÑADIR se RETIENE.
       No se toca la cesta hasta que el pop-up de upgrade decide:
       ACTUALIZAR añade el Protocolo (y marca su tarjeta), rechazar o
       cerrar añade el Starter. Así no existe nunca un carrito intermedio
       que arreglar. El pop-up es una pregunta pura (skdupPreguntar): si
       no está disponible o ya se ofreció en esta sesión, responde
       "Starter" al instante y el add sale directo: nunca se bloquea. */
    function planDelGel(gelAttr) {
      var root = document.querySelector('[data-skdup-popup]');
      if (!root) return null;
      var objetivo = root.getAttribute(gelAttr) || '';
      if (!objetivo) return null;
      for (var i = 0; i < plans.length; i++) {
        if ((plans[i].getAttribute('data-sub-variant') || '') === objetivo) return plans[i];
      }
      return null;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var plan = selectedPlan();
      if (!plan) return;

      var esStarter = plan === planDelGel('data-skdup-gel-repo');
      if (esStarter && typeof window.skdupPreguntar === 'function') {
        window.skdupPreguntar({
          siAceptar: function () {
            var protocolo = planDelGel('data-skdup-gel-auto');
            if (protocolo) {
              var input = protocolo.querySelector('[data-plan-input]');
              if (input && !input.disabled) input.click();
              ejecutarCompra(protocolo);
            } else {
              ejecutarCompra(plan);
            }
          },
          siRechazar: function () { ejecutarCompra(plan); }
        });
        return;
      }

      ejecutarCompra(plan);
    });

    sync();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-pdp-carousel]');
    Array.prototype.forEach.call(roots, initCarousel);

    var boxes = (scope || document).querySelectorAll('[data-buybox]');
    Array.prototype.forEach.call(boxes, initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* El editor de temas recarga secciones sueltas sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();

/* Promesa del advertorial (Mau, 2026-08-24): quien llega atribuido con
   ?ref=protocolofacial tiene 60 días de garantía ELIJA LO QUE ELIJA,
   porque el advertorial lo publica así ("o te encanta o no pagas"). El
   HTML trae las dos variantes de cada pieza (la normal visible, la del
   advertorial con display:none inline) y aquí solo se intercambian:
   los textos viven en settings del theme, no en este archivo. Piezas
   marcadas hoy: chips del Starter (rosa, 60 días), itálica de la
   promesa, y el bullet "ampliada a 60" del pop-up de upgrade (se
   esconde: para ellos no es mejora).

   La cookie skd_ref la escribe js-skindion-atribucion.js (head, defer,
   corre antes; ventana de 14 días, la MISMA atribución que taguea la
   orden para el Flow). Se lee la cookie directamente y no la variable
   global, el patrón de js-product-urgencia: si aquel script no cargó,
   esto no enseña nada y la página queda como para tráfico normal. */
(function () {
  'use strict';

  function esDelAdvertorial() {
    var partes = ('; ' + document.cookie).split('; skd_ref=');
    if (partes.length !== 2) return false;
    var crudo = decodeURIComponent(partes.pop().split(';').shift() || '');
    return crudo.split('|')[0] === 'protocolofacial';
  }

  function aplicar() {
    if (!esDelAdvertorial()) return;
    var on = document.querySelectorAll('[data-advertorial-on]');
    var off = document.querySelectorAll('[data-advertorial-off]');
    for (var i = 0; i < on.length; i++) on[i].style.display = '';
    for (var j = 0; j < off.length; j++) off[j].style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicar);
  } else {
    aplicar();
  }
  document.addEventListener('shopify:section:load', aplicar);
})();
